var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2HealthStackedBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_4201)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 14,
    height: 14,
    rx: 1.5,
    stroke: "#7A7670",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7692 15H17.5C18.3284 15 19 14.3284 19 13.5V2.5C19 1.67157 18.3284 1 17.5 1H6.5C5.67157 1 5 1.67157 5 2.5V4.23077",
    stroke: "#7A7670",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.8C3.5 7.63431 3.63431 7.5 3.8 7.5H12.2C12.3657 7.5 12.5 7.63431 12.5 7.8V16.2C12.5 16.3657 12.3657 16.5 12.2 16.5H3.8C3.63431 16.5 3.5 16.3657 3.5 16.2V7.8Z",
    stroke: "#7A7670",
    strokeLinecap: "round",
    strokeDasharray: "1.2 1.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_4201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2HealthStackedBox);
export default __webpack_public_path__ + "static/media/customV2HealthStackedBox.9e993f1e7837c87f5b53a6df2685f84e.svg";
export { ForwardRef as ReactComponent };